(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('RingphoneOfficesOverviewController', [
        'ItemTableService',  
        'RingphoneOfficeService',
        '$translate',
        'Alert',
        'HelperService',
         RingphoneOfficesOverviewControllerFn
    ]);
    
    function RingphoneOfficesOverviewControllerFn(
            ItemTableService, 
            RingphoneOfficeService,
            $translate, 
            Alert,
            HelperService) {
        var vm = this; 

        // table service data
        vm.overview = null;

        // office that is being edited
        var office = null;        

        activate();

        function activate() {
            vm.overview = ItemTableService;            
            loadRingphoneOffices();
        }

        function loadRingphoneOffices() {
            RingphoneOfficeService.getRingphoneOffices()
                                  .then(function(offices) {
                                       // init table-item list
                                       vm.overview.init(offices);                                       
                                  });
        }

        vm.add = function() {
            ItemTableService.add();
        }

        vm.delete = function(item) {
            var confirmationModal = HelperService.deactivatingConfirmationModal();
            confirmationModal.result.then(function() {
                RingphoneOfficeService.deleteRingphoneOffice(item.id)
                    .then(function() {
                        ItemTableService.deactivate(item, item.vmIndex);
                        loadRingphoneOffices();
                        Alert.success($translate.instant('ringphone_office_removed'));
                    });
                });                    
        };

        vm.edit = function(item) {
            office = ItemTableService.edit(item);
        };

        vm.cancel = function(item) {
            if (!office) {
                ItemTableService.remove(item.vmIndex);
            }
            else {
                // replace original with current edited item
                ItemTableService.replace(office, item.vmIndex);
                // remove backup
                office = null;
            }
        }

        vm.save = function(item) {
            if (item.id > 0) {
                return RingphoneOfficeService.updateRingphoneOffice(item.id, {
                    name: item.name,
                    ipAddress: item.ipAddress
                }).then(function(savedRingphoneOffice) {
                    ItemTableService.save(item);                    
                    Alert.success($translate.instant('ringphone_office_updated'));
                });
            } else {
                return RingphoneOfficeService.createRingphoneOffice({
                    name: item.name,
                    ipAddress: item.ipAddress
                }).then(function(savedRingphoneOffice) {
                    item.id = savedRingphoneOffice.id;
                    ItemTableService.save(item);  
                    Alert.success($translate.instant('ringphone_office_created'));
                });
            }
        }
    }
})();